import { docUrls, getAppConfigFromStorage } from '@mgk-eld/utils';
import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export const Documentation: React.FC = () => {
  const navigate = useNavigate();

  const appConfig = useMemo(getAppConfigFromStorage, []);

  const name = appConfig?.name ?? '';

  useEffect(() => {
    const downloadDocs = () => {
      const files = docUrls[name.toUpperCase() as keyof typeof docUrls];
      if (!files) {
        console.error('No documents found for', name);
        return;
      }
      for (const file of files) {
        const a = document.createElement('a');
        a.href = encodeURI(file.url);
        a.download = file.docName;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      navigate(-1);
    };
    downloadDocs();
  }, [name, navigate]);

  return null;
};
